import { Paper } from '@material-ui/core';
import dayjs from 'dayjs';
import Pluralize from 'react-pluralize';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import InfoBlock from '../../InfoBlock';
import useDropdownButtonStyles from '../ViewTripConfigurationItems/TripBookButton/styles/dropdownButtonStyles';
import formatStateroomsInput from '../../../helpers/formatStateroomsInput';

const CustomInventoryInfo = ({ itinerary }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const classes = useDropdownButtonStyles();
  const { staterooms } = useSelector((store) => store.tripSearch.searchObj);
  const product = itinerary.products.find((item) => item.id === itinerary.selectedProductId);
  return (
    <>
      <div className="grid grid-cols-4 gap-1">
        <div className="row-start-1 row-end-3">
          {itinerary.image ? (
            <img src={itinerary.image} alt="IMG" />
          ) : (
            <Paper square classes={classes}>
              No photo
            </Paper>
          )}
        </div>
        <div className="col-start-2 col-end-5 truncate">{itinerary.name}</div>
        <div className="col-start-2 col-end-5 truncate">{product.name}</div>
      </div>
      <InfoBlock title={`${itinerary.type} details`}>
        <div className="grid grid-cols-2 text-sm">
          <div>{travelAgency.searchbarTab.searchFormStartDateLabel}:</div>
          <div>{dayjs(itinerary.startDateTime).format('ddd D MMM, YYYY')}</div>
          <div>{travelAgency.searchbarTab.searchFormEndDateLabel}:</div>
          <div>{dayjs(itinerary.endDateTime).format('ddd D MMM, YYYY')}</div>
          {itinerary.duration ? (
            <>
              <div>Duration:</div>
              <div>
                <Pluralize singular="night" count={itinerary.duration} />
              </div>
            </>
          ) : (
            ''
          )}
          <div>Travelers:</div>
          <div>
            {formatStateroomsInput(staterooms, travelAgency && travelAgency.enabledTransportModes)}
          </div>
          <div>Destination:</div>
          <div>{itinerary.destination}</div>
        </div>
      </InfoBlock>
    </>
  );
};

CustomInventoryInfo.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default memo(CustomInventoryInfo);
